
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 11">
  <path
    d="M0.75 0.75H12V2.15625H0.75V0.75ZM0.75 9.1875H7.78125V10.5938H0.75V9.1875ZM0.75 4.96875H12V6.375H0.75V4.96875Z"
    fill="currentColor"
  ></path>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'List',
    }) as DefineComponent
    </script>
    